import React from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';

export const badgeColors = [
  'blue',
  'green',
  'light-gray',
  'dark-gray',
  'purple',
  'red',
  'yellow',
  'secondary-dark',
  'white',
  'transparent',
] as const;

type BadgeColor = typeof badgeColors[number];

export type BadgeProps = {
  size?: 'small' | 'medium';
  color?: BadgeColor;
  outlined?: boolean;
  hoverable?: boolean;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLSpanElement>;

export const Badge = ({
  size,
  color = 'blue',
  outlined,
  hoverable,
  children,
  className,
  ...props
}: BadgeProps): React.ReactElement => {
  const theme = useTheme();
  const classNames = classnames(className, 'airtame-badge', `airtame-badge--${color}`, {
    'airtame-badge--small': size === 'small',
    'airtame-badge--outlined': outlined,
    'airtame-badge--hoverable': hoverable,
  });
  return (
    <span className={classNames} data-theme={theme} {...props}>
      {children}
    </span>
  );
};

Badge.displayName = 'Badge';
